import { useSuspenseQuery } from '@tanstack/react-query';
import type { Partnership } from '../types';
import queryKeys from './queryKeys';
import type { QueryConfig } from 'lib/react-query';
import { apiClient } from 'lib/api';
import type { ListResponse, SortingParams } from 'types/shared';

interface GetPartnershipsParams extends Partial<SortingParams> {
  tag?: string;
  status?: string;
  limit?: number;
  offset?: number;
}

export const getPartnerships = async (
  params?: GetPartnershipsParams,
  signal?: AbortSignal,
): Promise<ListResponse<Partnership>> => {
  const res = await apiClient.get<ListResponse<Partnership>>(
    queryKeys.partnerships,
    {
      signal,
      params,
    },
  );
  return res.data;
};

interface UsePartnershipsOptions<TData> {
  config?: QueryConfig<typeof getPartnerships, TData>;
  params?: GetPartnershipsParams;
}

export const usePartnerships =
  <TData = ListResponse<Partnership>>({ config, params }: UsePartnershipsOptions<TData> = {}) => {
  return useSuspenseQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getPartnerships(params, signal),
    queryKey: [queryKeys.partnerships, params],
  });
};
